//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { loginToChainFunction } from '@react/chainThunks/loginToChainThunk'
import { chainActions } from '@react/redux/chainSlice'
import { useOtChainState, useOtDispatch, useOtSelector } from '@react/redux/store'
import { useAppKitAccount, useAppKitNetwork, useAppKitProvider, type Provider } from '@reown/appkit/react'
import { getRequiredAddress } from '@shared/conversions'
import { convertToAppKitNetwork } from '@shared/DeploymentConfigs'
import { RoleEnum, WalletEnum } from '@shared/Enums'
import { logOT } from '@shared/loggingShared'
import { BrowserProvider, JsonRpcSigner } from 'ethers'
import React, { useEffect, useState } from 'react'
import { appKitNetworks } from './AppKitWrapper'

let globalIsLoggingIn = false
export const AppKitListener = (): React.ReactNode => {
  const { isInitialized } = useOtSelector((state) => state.poolState)
  const { chainId: appKitChainId, switchNetwork } = useAppKitNetwork()
  const {
    chainConfiguration: { chainConfigurationName, chainId: chainConfigChainId },
    userConnection: { accountAddr },
  } = useOtChainState()
  const { chainConfiguration } = useOtChainState()
  const chainState = useOtChainState()
  const poolOverviewCTOs = useOtSelector((state) => state.poolState.poolOverviewCTOs)

  const { isConnected, address } = useAppKitAccount({ namespace: 'eip155' })
  const { walletProvider } = useAppKitProvider<Provider>('eip155')
  const dispatch = useOtDispatch()
  const [isLoggingIn, setIsLoggingIn] = useState(false)

  // logOT.debug('AppKitEthersSetupWrapper allAccounts', allAccounts)
  const {
    userConnection: { signer },
  } = useOtChainState()

  logOT.debug('AppKit AppKitListener  appKitChainId', appKitChainId, chainConfigChainId)

  /* Logoff if the account changes in the wallet */
  useEffect(() => {
    // if (walletProvider && address && (accountAddr ?? '').toLowerCase() !== (address ?? '').toLowerCase()) {
    //   const appKitNetwork = convertToAppKitNetwork(chainConfiguration)
    //   logOT.debug('AppKitListener appKitNetwork', appKitNetwork)

    //   if (appKitChainId !== chainId) {
    //     logOT.debug(
    //       'connectToChainThunk chainConfigurationName NETWORK SWITCH  AppKitListener address mismatch',
    //       accountAddr,
    //       address,
    //       appKitChainId,
    //       chainId
    //     )
    //     // switchNetwork(appKitNetwork as any)
    //   }
    //   const provider = new BrowserProvider(walletProvider, chainId)
    //   const signer = new JsonRpcSigner(provider, address)
    //   signer.getAddress().then((providerAddress) => {
    //     logOT.debug(
    //       'AppKitListener accountAddr !== address',
    //       accountAddr,
    //       address,
    //       providerAddress,
    //       walletProvider,
    //       embeddedWalletInfo
    //     )
    //   })
    // }
    if (accountAddr && accountAddr?.toLowerCase() !== address?.toLowerCase()) {
      logOT.debug('AppKitListener  Logoff accountAddr !== address', accountAddr, address)
      dispatch(chainActions.logoffUser())
    }
  }, [accountAddr, address])

  // useEffect(() => {
  //   if (roleEnum === RoleEnum.LENDER && location.hostname.startsWith('admin.')) {
  //     disconnect()
  //       .then(() => {
  //         logOT.debug('Disconnected from AppKit')
  //         return dispatch(chainActions.logoffUser())
  //       })
  //       .catch((error) => {
  //         logOT.error('FOCUS: LogoutButton error', error)
  //       })
  //   }
  //   if ((roleEnum === RoleEnum.POOL_ADMIN || roleEnum == RoleEnum.BORROWER) && location.hostname.startsWith('app.')) {
  //     disconnect()
  //       .then(() => {
  //         logOT.debug('Disconnected from AppKit')
  //         return dispatch(chainActions.logoffUser())
  //       })
  //       .catch((error) => {
  //         logOT.error('FOCUS: LogoutButton error', error)
  //       })
  //   }
  // }, [roleEnum])

  useEffect(() => {
    // if (signer) {
    //   logOT.debug('AppKitListener setIsLoggingIsFalse signer:')
    //   setIsLoggingIn(false)
    // }
    // if (signer && !walletProvider) {
    //   logOT.debug('AppKitListener signer && !walletProvider', signer, walletProvider)
    //   dispatch(chainActions.logoffUser())
    // }
    // if (chainConfigChainId !== appKitChainId) {
    //   logOT.debug('AppKitListener chainConfigurationName currentChainId !== chainId', chainConfigChainId, appKitChainId)
    //   const nextStageConfig = chainConfigurations.find((config) => config.chainId === appKitChainId)
    //   const chainConfigurationName = nextStageConfig?.chainConfigurationName
    //   logOT.debug(
    //     'AppKitListener chainConfigurationName currentChainId !== chainId',
    //     chainConfigChainId,
    //     appKitChainId,
    //     nextStageConfig
    //   )
    //   localStorage.setItem('chainConfigurationName', chainConfigurationName ?? '')
    //   window.location.href = '/'
    // }
  }, [signer, walletProvider, appKitChainId, chainConfigChainId])

  /* Login connect account from wallet */
  useEffect(() => {
    const asyncFunction = async () => {
      if (appKitChainId !== chainConfiguration.chainId) {
        logOT.debug('QQQQQQ AppKitListener switchNetwork', appKitChainId, chainConfiguration.chainId)
        const appKitNetwork = convertToAppKitNetwork(chainConfiguration)
        switchNetwork(appKitNetwork as any)
        return
      }

      if (!isLoggingIn && isConnected && walletProvider && address && !signer && isInitialized) {
        logOT.debug('QQQQQ AppKitListener Login  CHAINS MATCH')
        const chainConfigNameLocalStorage = localStorage.getItem('chainConfigurationName')
        if (chainConfigNameLocalStorage !== chainConfigurationName) {
          window.location.href = '/'
          return
        }

        const appKitNetwork = convertToAppKitNetwork(chainConfiguration)
        logOT.debug('QQQQ AppKitListener appKitNetwork', appKitNetwork)

        switchNetwork(appKitNetwork as any)

        logOT.debug('QQQQQQ AppKitListener switchNetwork done')

        const network = appKitNetworks.find((network) => network.id === appKitChainId)
        logOT.debug('QQQQQQ AppKitListener network', network)

        const provider = new BrowserProvider(walletProvider, {
          name: network?.name,
          chainId: chainConfiguration.chainId,
        })
        logOT.debug('QQQQQQ AppKitListener BrowserProvider', provider, await provider.getNetwork())
        const signer = new JsonRpcSigner(provider, getRequiredAddress(address))
        logOT.debug('QQQQQQ AppKitListener signer', signer)

        await loginToChainFunction(
          dispatch,
          poolOverviewCTOs,
          chainState,
          signer,
          WalletEnum.APP_KIT,
          RoleEnum.TO_BE_DETERMINED
        )

        logOT.debug('AppKitListener loginToChainFunction done')
      }
    }

    if (address && accountAddr && address.toLowerCase() != accountAddr.toLowerCase()) {
      window.location.href = '/'
    }

    if (!globalIsLoggingIn && !isLoggingIn && isConnected && isInitialized && address && !signer) {
      logOT.debug('AppKitListener isLoggingIn SET  TRUE')
      setIsLoggingIn(true)
      globalIsLoggingIn = true
      asyncFunction()
        .then(() => {
          setIsLoggingIn(false)
          globalIsLoggingIn = false
        })
        .catch((error) => {
          logOT.error('QQQQQ AppKitListener asyncFunction error', error)
          setIsLoggingIn(false)
          globalIsLoggingIn = false
        })
    }
  }, [isLoggingIn, isConnected, walletProvider, address, appKitChainId, isInitialized])

  return <></>
}
